import { selectJoinConversationManager } from '../selectors/conversation';
import { useAppSelector } from '../store/store';
export default function useJoinConversationManager() {
    const joinConversationManager = useAppSelector(selectJoinConversationManager);
    return joinConversationManager;
}
